export default __webpack_public_path__ + "883a5a4edd9b45bb160546a420125470.svg";